import { render } from "./Mywallets.vue?vue&type=template&id=ec1bbad8"
import script from "./Mywallets.vue?vue&type=script&lang=js"
export * from "./Mywallets.vue?vue&type=script&lang=js"
script.render = render

export default script